export class ComplementType {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ComplementType(
      this.hash,
      this.name
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/complement-type.ts